"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _canteen = require("@/api/canteen");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProductType',
  props: {
    // 可以添加需要的 props
  },
  data: function data() {
    return {
      dialogVisible: false,
      currentMode: 'add',
      // 当前模式：add/edit/view
      formData: {
        value: '',
        creator: "1",
        updater: "1",
        deleted: false,
        sort: 1,
        label: "",
        dictType: "dish:category",
        status: 0
      },
      rules: {
        value: [{
          required: true,
          message: '请输入商品分类',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '长度在 2 到 20 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return {
        add: '添加商品分类',
        edit: '修改商品分类',
        view: '查看商品分类'
      }[this.currentMode];
    },
    isViewMode: function isViewMode() {
      return this.currentMode === 'view';
    }
  },
  methods: {
    openDialog: function openDialog() {
      var _this = this;
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';
      this.currentMode = mode;

      // 填充表单数据（编辑/查看模式）
      if (row) {
        this.formData = _objectSpread(_objectSpread({}, row), {}, {
          id: row.id,
          value: row.value
        });
      } else {
        // 重置表单（添加模式）
        this.formData = {
          id: null,
          value: ''
        };
      }
      this.dialogVisible = true;

      // 清除表单验证
      if (this.$refs.form) {
        this.$nextTick(function () {
          _this.$refs.form.clearValidate();
        });
      }
    },
    onClose: function onClose() {
      this.dialogVisible = false;
      this.$emit('closeDialog');
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var payload = _objectSpread(_objectSpread({}, _this2.formData), {}, {
            label: _this2.formData.value,
            sort: 1,
            dictType: "dish:category"
          });
          // 根据模式调用不同API
          var apiMethod = _this2.currentMode === 'add' ? _canteen.dictDataCreate : _canteen.dictDataUpdate;
          // 根据模式调用不同API
          apiMethod(payload).then(function () {
            _this2.$message.success("".concat(_this2.dialogTitle, "\u6210\u529F"));
            _this2.$emit('success');
            _this2.onClose();
          }).catch(function (error) {
            console.error('操作失败:', error);
            _this2.$message.error("".concat(_this2.dialogTitle, "\u5931\u8D25"));
          });
        }
      });
    }
  }
};